import React, { Component } from 'react';
import { OrderType } from './OrderType';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, Alert, Confirm, NoResult, BannerAd } from '../../../js/ComponentManager'
import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능: 장바구니 메인
 * 세부설명:
*/


export class BasketList extends Component {
    static displayName = BasketList.name;

    constructor(props) {
        super(props);
        this.state = {
            Content:"",
            BasketMaster: [],
            BasketDetail: [],
            isOk: false
        };
       
        this.OrderTypeRef = React.createRef(); 

        this.handleQuan_Change = this.handleQuan_Change.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.handleBuy_Click = this.handleBuy_Click.bind(this);
        this.CallMyBasketListData = this.CallMyBasketListData.bind(this);
        this.handleStock_Click = this.handleStock_Click.bind(this);
        this.handleQuanChange_Save = this.handleQuanChange_Save.bind(this);
    }
    //초기화
    componentDidMount() {

        this.CallMyBasketListData();
    }
    async CallMyBasketListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get('api/MyPage/Basket/GetMyBasketList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                let BasketMaster = DataList.Master;
                let BasketDetail = DataList.Detail;
                let SoldOutData = BasketMaster.filter(list => list.soldout_yn === "Y");
                if (SoldOutData.length > 0) {
                    SoldOutData.map(mstlist => {
                        BasketDetail.filter(list => mstlist.uid === list.uid && mstlist.goods_no === list.goods_no).map(sel => sel.selected = "N");
                        return false;
                    });
                }
                this.setState({
                    BasketMaster: BasketMaster,
                    BasketDetail: BasketDetail
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallMyBasketListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //장바구니 개수 변경
    handleQuan_Change(event, list, plus, soldout_yn, sinsale_yn) {
        let Type = event.target.type;
        let Value = 0;
        let Quan = list.quan;
        let Totalprice = 0;
        if (soldout_yn === "Y") {
            this.setState({ Content: "Soldout 제품은 변경할 수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan === 1 && plus < 0) {

            this.setState({ Content: "구매수량은 1보다 작을수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan >= 999) {
            this.setState({ Content: "구매수량은 1000보다 클수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }

        if (Type === "text") {

            Value = event.target.value;
            if (Big3Common.Util.isNumber(Value) === false) {
                return false;
            }
            Quan = Value === "" ? "" : parseInt(Value);
        }
        else {
            Quan = Quan + (plus);
        }
        if (Quan <1) {
            this.setState({ Content: "구매수량은 1보다 작을수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (sinsale_yn === "N" && Quan < 2) {
            this.setState({ Content: "낱장판매 불가제품 입니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        Totalprice = (Quan === "" ? 0 : Quan  * list.goods_price);
        list.quan = Quan;
        list.total_price = Totalprice;
        this.setState({ isOk: true });
        event.preventDefault();
    }
    //장바구니 변경개수 저장
    handleQuanChange_Save = async (event,list) => {
        let Model = {
            uid: list.uid,
            goods_no: list.goods_no,
            crd_cd: list.crd_cd,
            sizgrp_cd: list.sizgrp_cd,
            siz_cd: list.siz_cd,
            quan: list.quan
        }
        try {
            let Data = await Big3Common.Post('api/MyPage/Basket/ModifyQuanValue', Model);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.CallMyBasketListData();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleQuanChange_Save", e);
        }
        event.preventDefault();
    }
    async handleDelete_Click(event, list, Type) {
         
        if (Type === "all") {
            try {

                if (this.state.BasketMaster.length === 0) {
                    this.setState({ Content: "삭제할 내용이 없습니다." });
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                    return false;
                }
                let Data = await Big3Common.Post('api/MyPage/Basket/RemoveBasketMgtAll', {});
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.CallMyBasketListData();
                }
                else {
                    console.log(Data.message);
                }
            }
            catch (e) {
                console.log("handleDelete_Click", e);
            }
            return false;
        }
        else if (Type === "many") {
                try {
                    let Data = await Big3Common.Post('api/MyPage/Basket/RemoveBasketMgtAll', {
                        uid: list.uid,
                        goods_no: list.goods_no
                    });
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        this.CallMyBasketListData();
                    }
                    else {
                        console.log(Data.message);
                    }
                }
                catch (e) {
                    console.log("handleDelete_Click", e);
                }
        }
        else {

                try {     
                    
                    let Data = await Big3Common.Post('api/MyPage/Basket/RemoveBasketMgt', {
                        uid: list.uid,
                        goods_no: list.goods_no,
                        crd_cd: list.crd_cd,
                        sizgrp_cd: list.sizgrp_cd,
                        siz_cd: list.siz_cd
                    });
                    if (Data.codeName === Big3Common.ResultCode.Success) {
                        this.CallMyBasketListData();
                    }
                    else {
                        console.log(Data.message);
                    }
                }
                catch (e) {
                    console.log("handleDelete_Click", e);
                }
        }
        event.preventDefault();
    }
    //주문하기 체크박스 선택
    handleCheck_Click(event, list) {

        let BasketData = [];
        let selected = event.target.checked === true ? "Y" : "N";
        if (list === undefined) {
            BasketData = this.state.BasketMaster.map(MasterData => {
                if (MasterData.soldout_yn === "N") {
                    MasterData.selected = selected;
                    this.state.BasketDetail.filter(list => list.uid === MasterData.uid && list.goods_no === MasterData.goods_no).map(DetailData => {
                        DetailData.selected = selected;
                        return false;
                    });
                }
                return false;
            });
          
            this.setState({ isOk: true });
        }
        else {
            if (list.quan === undefined) {
                //마스터
                BasketData = this.state.BasketMaster.filter(Data => Data.rownum === list.rownum);
                BasketData.map(MasterData => {
                    MasterData.selected = selected;
                    this.state.BasketDetail.filter(subData => subData.uid === MasterData.uid && subData.goods_no === MasterData.goods_no).map(DetailData => {
                        DetailData.selected = selected;
                        return false;
                    });
                    return false;
                });
                this.setState({ isOk: true });
            }
            else {
                //상세
                BasketData = this.state.BasketDetail.filter(Data => Data.rownum === list.rownum)
                    .map(DetailData => {
                        DetailData.selected = selected;
                        return false;
                    });
                this.setState({ isOk: true });
            }
        }
               
        return false;
    }
    //구매하기
    handleBuy_Click(event) {
        let Model = this.state.BasketDetail.filter(list => list.selected === "Y");
        /*if (this.state.BasketMaster.length > 2) {
            Model.push({
                goods_nm: this.state.BasketMaster[0].goods_nm
            })
        }
        Model.push({
            goods_nm: this.state.BasketMaster[0].goods_nm
        })*/
        if (Model.length === 0) {
            this.setState({ Content: "구매할 상품을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        this.OrderTypeRef.current.GoodsParameterSet(Model);
        Big3Common.ModalAlert(bootstrap, "OrderType");       
        event.preventDefault();
    }
    //재고 문의하기
    async handleStock_Click(event) {

        try {
            let Model = this.state.BasketDetail.filter(list => list.selected === "Y");
            if (Model.length === 0) {
                this.setState({ Content: "문의할 상품을 선택하여 주세요." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else {
                let DataGroup = Big3Common.Util.groupBy(Model, list => list.uid);
                let Mstlist = [];
                let DtlList = [];
                for (const item of DataGroup.entries()) {
                    //QA: 재고문의
                    Mstlist.push({ "uid": item[0], "QST_STATUS": "QA" });
                    let itemList = item[1];
                    itemList.forEach(element => DtlList.push(element));
                }
                
                let Data = await Big3Common.Post('api/Chat/Answer/RegisterStockQustion', { Mstlist: Mstlist, DtlList: DtlList } , true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                }
                else {
                    this.setState({ Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                }
            }
        }
        catch (e) {
            console.log("handleStock_Click", e);
        }
        event.preventDefault();
    }
    BasketDetailrender(uid, goods_no, soldout_yn, sinsale_yn) {        
        let DataDetail = this.state.BasketDetail.filter(Data => Data.uid === uid && Data.goods_no === goods_no);        
        return(
            <>
                {DataDetail.map(list =>
                    <div className="product_order" key={`${list.rownum}` }>
                        <div className="product_choice">
                            <input  
                                className={soldout_yn === "N" ? "form-check-input" : "item_hide"}
                                type="checkbox"
                                checked={list.selected === "Y" ? true : false}
                                onChange={(e) => { this.handleCheck_Click(e, list) }}
                            />
                        </div>
                        <div className="product_order_info">
                            <div className="product_name">{list.crd_cd_nm}  /  {list.siz_cd_nm}</div>
                            <div className="product_order_data">
                                <div className="number_check">
                                    <button type="button" onClick={(e) => { this.handleQuan_Change(e, list, -1, soldout_yn, sinsale_yn) }}>-</button>
                                    <input type="text"
                                        className="form-control"
                                        value={list.quan}
                                        maxLength="3"
                                        onChange={(e) => { this.handleQuan_Change(e, list, 0, soldout_yn, sinsale_yn) } }
                                    />
                                    <button type="button" className="btn_2" onClick={(e) => { this.handleQuan_Change(e, list, 1, soldout_yn, sinsale_yn) }}>+</button>
                                    <div className="n_check_btn" onClick={(e) => { this.handleQuanChange_Save(e,list) } }>변경</div>
                                </div>
                                <div className="product_price">{Big3Common.Util.Money(list.total_price)}원</div>
                                <div className="product_delete" onClick={(e) => { this.handleDelete_Click(e, list, 'one') }}></div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="total_amount">
                    <div className="total">합계 금액</div>
                    <div className="amount">{Big3Common.Util.Money(DataDetail.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.total_price } return acc; }, 0))}원</div>
                </div>
            </>
            )
    }
    BasketMasterrender() {
        let DataList = this.state.BasketMaster;
      
        return (
            <>
                {DataList.map(list =>
                    <div className="basket_box" key={`${list.rownum}` }>
                        <div className="shop_box">
                            <div className="shop_name">{list.whole_name}</div>
                            <div className="call" onClick={() => { window.location.href = `tel:${list.user_phone}` }}></div>
                        </div>
                        <div className="product_box">
                            <div className="product_choice">
                                <input  
                                    className={list.soldout_yn === "N" ? "form-check-input" : "item_hide"}
                                    type="checkbox"
                                    checked={list.selected === "Y" ? true : false}
                                    onChange={(e) => { this.handleCheck_Click(e,list) } }
                                />
                            </div>
                            <div className="product_detail">
                                <div className="product_img_box">
                                    <Link to={`/Search/Goods/Index?Goods_No=${list.goods_no}&Uid=${list.uid}`}>
                                        <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                            SoldoutYn={list.soldout_yn}
                                        />
                                    </Link>
                                    
                                </div>
                                <div className="product_info">
                                    <div className="product_name">{list.goods_nm}</div>
                                    <div className="product_state">{list.sinsale_yn_nm}</div>
                                    <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price) }원` }</div>
                                    <div className="product_delete" onClick={(e) => {this.handleDelete_Click(e,list,'many') }}></div>
                                </div>
                            </div>
                        </div>
                        {this.BasketDetailrender(list.uid, list.goods_no, list.soldout_yn, list.sinsale_yn)}
                       
                    </div>
               )}
            </>
            )
    }
    render() {
        
        let BasketMasterrender = this.BasketMasterrender();
        let BasketDetail = this.state.BasketDetail.filter(list => list.selected === "Y");
        return (
            <div>
                <div className="container_box u_padding b_margin" >
                    <BannerAd id="BasketBanner" ads_loc_cd="BS" ads_type_detail_cd="SB" />
                   {/* <!-- 전체선택/전체삭제-->*/}
                    <div className="all_box">
                        <div className="all_choise">
                            <input className="form-check-input"
                                type="checkbox"
                                onChange={(e) => { this.handleCheck_Click(e) }}
                            />
                            <label className="form-check-label">
                                전체선택
                            </label>
                        </div>
                        <div className="all_delete" onClick={() => { Big3Common.ModalAlert(bootstrap, 'ConfirmBox'); }}>
                            전체삭제
                        </div>
                    </div>
                    
                    {BasketMasterrender}                   
                    <div className="order_box">
                        <div className="all_total_amount">
                            <div className="total">총 합계</div>
                            <div className="amount">{Big3Common.Util.Money(BasketDetail.reduce((acc, item) => { if (item.selected === "Y") { return acc + item.total_price } return acc; }, 0))}원</div>
                        </div>
                        <div className="order_btn_box">
                            <button type="button" className="order_btn btn_v1"
                                onClick={(e) => { this.handleStock_Click(e) }}
                            >재고문의</button>
                            <button type="button" className="order_btn btn_v1"
                                onClick={(e) => { this.handleBuy_Click(e); }}
                            >주문하기</button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="주문안내"
                />
                <Confirm
                    id="ConfirmBox"
                    title="주문안내"
                    content="장바구니 전체를 삭제하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleDelete_Click(e, null,'all');
                    }}
                />
                <OrderType id="OrderType"
                    ref={this.OrderTypeRef}
                    CallBack={this.CallMyBasketListData }
                />
                <NoResult
                    CssName="icon2"
                    Text="주문내역이 없습니다."
                    Visible={this.state.BasketMaster.length === 0 ? true : false}
                    Top={"50%"}
                />
            </div>
        );
    }
}
